import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

/**
 * Schema for intake request from external landing pages
 */
export const intakeRequestSchema = z.object({
  jobRole: z.string().min(1, "Job role is required"),
  language: z.string().default("EN"),
  country: z.string().default("US"),
  experience: z.string().default("2-4"),
  tone: z.string().default("Professional"),
  additionalDescription: z.string().optional().default(""),
  jobUrl: z.string().optional().default(""),
  source: z.string().optional().default(""),
  campaign: z.string().optional().default(""),
  autoStart: z.boolean().optional().default(true),
  /** Optional browser fingerprint from embed (same semantics as guest session) */
  fingerprint: z.string().max(256).optional(),
});

export type IntakeRequest = z.infer<typeof intakeRequestSchema>;

export class IntakeRequestDto extends createZodDto(intakeRequestSchema) {}

/**
 * Schema for intake response returned to landing pages
 */
export const intakeResponseSchema = z.object({
  success: z.boolean(),
  redirectUrl: z.string().url(),
  expiresAt: z.string().datetime(),
  message: z.string().optional(),
});

export type IntakeResponse = z.infer<typeof intakeResponseSchema>;

/**
 * Schema for redeeming an intake token
 */
export const redeemTokenRequestSchema = z.object({
  token: z.string().min(1, "Token is required"),
});

export type RedeemTokenRequest = z.infer<typeof redeemTokenRequestSchema>;

export class RedeemTokenRequestDto extends createZodDto(redeemTokenRequestSchema) {}

/**
 * Schema for redeem token response
 */
export const redeemTokenResponseSchema = z.object({
  success: z.boolean(),
  formData: intakeRequestSchema.omit({ source: true, campaign: true }).optional(),
  guestId: z.string().optional(),
  message: z.string().optional(),
});

export type RedeemTokenResponse = z.infer<typeof redeemTokenResponseSchema>;
